import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

type Props = {
  open: boolean;
  title?: string;
  message?: string;
  saving?: boolean;
  onSave: () => void | Promise<void>;
  onDiscard: () => void;
  onCancel: () => void;
};

export class FUnsavedChangesDialog extends React.Component<Props> {
  render() {
    const {
      open,
      title = 'Unsaved changes',
      message = 'You have unsaved changes. Save or discard them before continuing.',
      saving,
      onSave,
      onDiscard,
      onCancel,
    } = this.props;

    return (
      <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button color="error" onClick={onDiscard}>Discard</Button>
          <Button variant="contained" disabled={saving} onClick={onSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default FUnsavedChangesDialog;
